// src/pages/Home.js - Enhanced Version with new components
import React from 'react';
import './Home.css';

// Import Components
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import BeforeAfterSlider from '../components/BeforeAfterSlider';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import TransformRoofCTA from '../components/TransformRoofCTA';
// import WeatherAlert from '../components/WeatherAlert'; // REMOVED

function Home() {
  return (
    <div className="home">
      {/* Weather Alert - shows only when bad weather forecast */}
      {/* <WeatherAlert /> */} {/* REMOVED */}

      {/* Hero Section */}
      <Hero />

      {/* Services Overview Section */}
      <ServicesSection />

      {/* Before-After Section */}
      <BeforeAfterSlider />

      {/* Testimonials Section */}
      <Testimonials />

      {/* Why Choose Us Section */}
      <WhyChooseUs />

      {/* CTA Section */}
      <TransformRoofCTA />
    </div>
  );
}

export default Home;